
      var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M79 39.95C79 50.852 62.5 77 60 77S41 50.852 41 39.95C41 29.048 48.954 20 60 20s19 9.048 19 19.95Z",
  stroke: "#000",
  strokeWidth: 4.4
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 60,
  cy: 38.5,
  rx: 9,
  ry: 8.5,
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.147 71H32.185a4.5 4.5 0 0 0-3.78 2.058l-12.92 20C13.55 96.052 15.7 100 19.265 100h81.47c3.565 0 5.715-3.948 3.78-6.942l-12.92-20A4.5 4.5 0 0 0 87.814 71H75.852",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n  <path d=\"M79 39.95C79 50.8522 62.5 77 60 77C57.5 77 41 50.8522 41 39.95C41 29.0478 48.9543 20 60 20C71.0457 20 79 29.0478 79 39.95Z\" stroke=\"black\" stroke-width=\"4.4\"/>\r\n  <ellipse cx=\"60\" cy=\"38.5\" rx=\"9\" ry=\"8.5\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\"/>\r\n  <path d=\"M44.1471 71H32.1855C30.6579 71 29.2346 71.775 28.4057 73.0581L15.4848 93.0581C13.5503 96.0524 15.6998 100 19.2646 100H100.735C104.3 100 106.45 96.0524 104.515 93.0581L91.5943 73.0581C90.7654 71.775 89.3421 71 87.8145 71H75.8529\" stroke=\"black\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/location.51d1cc3d7c70d5f38f634c3a0f81b6e4.svg"),
        {
          React: SvgLocation,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      